module.exports = __webpack_public_path__ + "img/kip-sign.aa52c66c.svg";